<template>
  <div class="container mt-5 mb-md-4 py-5">
    <breadcrumb class="mb-3 mb-md-4 pt-md-3" :crumbs="crumbs"></breadcrumb>

    <!-- Page content -->
    <div class="row justify-content-center pb-sm-2 pt-3">
      <div class="col-lg-6">
        <h1 class="h2 text-center pb-4 mb-3">Create Your Account</h1>

        <div class="bg-light rounded-3 py-4 px-md-4">
          <form action="post" @submit.prevent="register">
            <!-- Name -->
            <div class="mb-4">
              <label class="form-label" for="name">Name <span class="text-danger">*</span></label>
              <input v-model="form.name" class="form-control form-control-lg" type="text" id="name"
                     placeholder="Enter your name" required>
            </div>
            <!-- / Name -->

            <!-- Email -->
            <div class="mb-4">
              <label class="form-label" for="email">Email <span class="text-danger">*</span></label>
              <input v-model="form.email" class="form-control form-control-lg" type="email" id="email"
                     placeholder="Enter your email address" required>
            </div>
            <!-- / Email -->

            <!-- Phone -->
            <div class="mb-4">
              <label class="form-label" for="phone">Phone</label>
              <input v-model="form.phone" class="form-control form-control-lg" type="tel" id="phone"
                     placeholder="Enter your phone number">
            </div>
            <!-- / Phone -->

            <!-- Company Name -->
            <div class="mb-4">
              <label class="form-label" for="company_name">Company Name</label>
              <input v-model="form.company_name" class="form-control form-control-lg" type="text" id="company_name"
                     placeholder="Enter your company name">
            </div>
            <!-- / Company Name -->

            <!-- Password -->
            <div class="mb-4">
              <label class="form-label" for="password">Password <span class="text-danger">*</span></label>
              <input v-model="form.password" class="form-control form-control-lg" type="password" id="password"
                     placeholder="Enter your password" required>
            </div>
            <!-- / Password -->

            <!-- Password Confirmation -->
            <div class="mb-4">
              <label class="form-label" for="password_confirmation">Confirm Password <span class="text-danger">*</span></label>
              <input v-model="form.password_confirmation" class="form-control form-control-lg" type="password" id="password_confirmation"
                     placeholder="Confirm your password" required>
            </div>
            <!-- / Password Confirmation -->

            <div class="mb-4">
              <div>
                    <!-- <input v-model="form.agree_to_terms" class="form-check-input" type="checkbox" id="agreeToTerms" :disabled="isSaving" required>
                    <label class="form-check-label" for="agreeToTerms">
                        I agree to the <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/682df97de4a6e87953bf3559__Syndesi%20Platform%20Terms%20-%2021_5_25.pdf" target="_blank">Terms of Service</a> and <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/67698cccb85d917b09a00bec_Syndesi%20Privacy%20Notice%20(1).pdf" target="_blank">Privacy Policy</a>
                    </label> -->
                    <label>
                            By signing up, you agree to Syndesi's <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/682df97de4a6e87953bf3559__Syndesi%20Platform%20Terms%20-%2021_5_25.pdf" target="_blank">Terms of Service</a> and <a href="https://cdn.prod.website-files.com/64943ca2ceb618f0fa485f81/68760cbc4c58f63d40c37040_Syndesi%20Privacy%20Notice%20(15_07_25).docx.pdf" target="_blank">Privacy Policy</a>
                    </label>
                </div>
            </div>

            <div class="mb-4">
                <div class="form-check">
                    <input v-model="form.marketing_consent" class="form-check-input" type="checkbox" id="marketingConsent" :disabled="isSaving">
                    <label class="form-check-label" for="marketingConsent">
                      I agree to receive updates and marketing communications from Syndesi 
                    </label>
                </div>
            </div>

            <input type="submit" class="d-none"/>

            <div class="actions-wrapper">
              <div class="left">
                <a :class="{'disabled': isLoading}"
                   @click.prevent="register" class="btn btn-primary btn-lg rounded-pill ms-sm-auto" href="#">
                  <spinner v-if="isLoading" class="spinner-border-sm me-2"></spinner>
                  <i v-else class="fi-user-plus fs-sm me-2"></i>
                  Register
                </a>
              </div>
              <div class="right">
                <a href="/login">Already have an account? Login</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- / Page content -->
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Spinner from "../components/Spinner";
import {mapGetters, mapActions} from 'vuex'
import axios from 'axios'
import { useToast } from 'vue-toastification'

const toast = useToast()

export default {
  components: {Breadcrumb, Spinner},
  data() {
    return {
      crumbs: [
        {
          href: '/',
          label: 'Home'
        },
        {
          href: '#',
          label: 'Register',
          active: true
        }
      ],
      form: {
        name: '',
        email: '',
        phone: '',
        company_name: '',
        password: '',
        password_confirmation: '',
        agree_to_terms: true,
        marketing_consent: false
      },
      error: null
    }
  },
  created() {
    this.clearWhitelabelConfiguration()
  },
  methods: {
    ...mapActions('auth', {
      handleUserRegistered: 'handleUserRegistered'
    }),
    ...mapActions('whitelabelConfiguration', {
      clearWhitelabelConfiguration: 'clearWhitelabelConfiguration'
    }),

    register() {
      let vm = this
      vm.isLoading = true
      vm.error = null
      axios.post(window.API_BASE + '/client-register', {
        name: vm.form.name,
        email: vm.form.email,
        password: vm.form.password,
        password_confirmation: vm.form.password_confirmation,
        phone: vm.form.phone,
        company_name: vm.form.company_name,
        agree_to_terms: vm.form.agree_to_terms,
        marketing_consent: vm.form.marketing_consent
      }).then(r => {
        vm.handleUserRegistered(r.data).then(() => {
          vm.isLoading = false
          vm.$router.push('/clients/find-a-lawyer')
        }).catch(e => {
          console.log(e)
          vm.isLoading = false
          vm.error = 'Error registering account'
          toast.error(vm.error)
        })
      }).catch(e => {
        console.log(e)
        vm.isLoading = false
        if (e.response && e.response.data && e.response.data.errors) {
          const errors = Object.values(e.response.data.errors).flat()
          if (errors.length > 0) {
            vm.error = errors[0]
            toast.error(vm.error)
          } else {
            vm.error = 'Error registering account'
            toast.error(vm.error)
          }
        } else {
          vm.error = 'Error registering account'
          toast.error(vm.error)
        }
      })
    }
  },
  computed: {
    ...mapGetters('auth', {
      isLoading: 'isLoading'
    })
  }
}
</script>

<style scoped lang="scss">
.actions-wrapper {
  display: flex;

  .left {
    flex-grow: 1;
  }

  .right {
    flex-shrink: 1;
    display: flex;
    align-items: center;
  }
}
</style> 